var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20833 5.45818H11.625L8.19792 2.0311C8.10028 1.93426 8.02279 1.81905 7.9699 1.69212C7.91702 1.56518 7.88979 1.42903 7.88979 1.29152C7.88979 1.154 7.91702 1.01785 7.9699 0.890915C8.02279 0.763978 8.10028 0.648769 8.19792 0.551932C8.39309 0.357921 8.6571 0.249023 8.93229 0.249023C9.20748 0.249023 9.4715 0.357921 9.66667 0.551932L14.1354 5.0311C14.5267 5.42001 14.7477 5.94821 14.75 6.49985C14.7449 7.04788 14.5241 7.57183 14.1354 7.95818L9.66667 12.4374C9.56954 12.5338 9.45438 12.6102 9.32774 12.6621C9.2011 12.714 9.06548 12.7405 8.92861 12.74C8.79174 12.7395 8.6563 12.7121 8.53004 12.6593C8.40377 12.6064 8.28915 12.5293 8.19271 12.4321C8.09627 12.335 8.0199 12.2198 7.96797 12.0932C7.91604 11.9666 7.88956 11.831 7.89005 11.6941C7.89053 11.5572 7.91797 11.4218 7.97079 11.2955C8.02362 11.1692 8.10079 11.0546 8.19792 10.9582L11.625 7.54152H1.20833C0.932065 7.54152 0.667112 7.43177 0.471762 7.23642C0.276411 7.04107 0.166666 6.77612 0.166666 6.49985C0.166666 6.22358 0.276411 5.95863 0.471762 5.76328C0.667112 5.56793 0.932065 5.45818 1.20833 5.45818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.3fd600d66958797fc3677c579d5a626a.svg";
export { ForwardRef as ReactComponent };